export default __webpack_public_path__ + "static/media/regiom-logo.d63dced8.svg";